import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import config from 'utils/config';
import { getUrlServiceHref } from 'utils/getUrlServiceHref';
import { NavMenuItem, NavMenuDivider } from 'components/NavMenu';
function isValidCustomLink(customLink) {
  var _customLink$title;
  return (customLink === null || customLink === void 0 ? void 0 : (_customLink$title = customLink.title) === null || _customLink$title === void 0 ? void 0 : _customLink$title.trim()) && customLink.url;
}
function getCustomLinks(_ref) {
  var customUserMenuLink1 = _ref.customUserMenuLink1,
    customUserMenuLink2 = _ref.customUserMenuLink2,
    customUserMenuLink3 = _ref.customUserMenuLink3;
  return [customUserMenuLink1, customUserMenuLink2, customUserMenuLink3].filter(isValidCustomLink);
}
function CustomUserMenuLinks() {
  var customLinks = getCustomLinks(config);
  if (customLinks.length === 0) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NavMenuDivider, null), customLinks.map(function (item) {
    return /*#__PURE__*/React.createElement(NavMenuItem, {
      as: "a",
      key: item.title,
      href: getUrlServiceHref(item.url)
    }, item.title);
  }));
}
export default CustomUserMenuLinks;